var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "spreadPic",
                    label: "宣传图片",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入宣传图片" },
                    model: {
                      value: _vm.model.spreadPic,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "spreadPic", $$v)
                      },
                      expression: "model.spreadPic",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "spreadContent",
                    label: "宣传内容",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入宣传内容" },
                    model: {
                      value: _vm.model.spreadContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "spreadContent", $$v)
                      },
                      expression: "model.spreadContent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }